import { DS } from '../../../design-system'
import DividerGradient from '../../../assets/divider-gradient.svg'
import { StyleSheet } from 'react-native'
import { Linking } from 'react-native'

const CancellationSurveyStep2 = () => {
  return (
    <DS.Frame style={styles.surveyContainer}>
      <DS.Frame style={styles.headerNumber}>
        <DividerGradient width={40} style={{ transform: [{ rotate: '180deg' }] }} />
        <DS.Text variant="Mini/Bold">02</DS.Text>
        <DividerGradient width={40} />
      </DS.Frame>

      <DS.Text style={styles.title} variant="Heading 5/Regular">
        Navigate to iOS Settings to cancel your membership
      </DS.Text>

      <DS.Frame style={styles.checkContainer}>
        <DS.Frame style={styles.stepContainer}>
          <DS.Icon name="Arrow---right" size={15} color="Global/Black" />
          <DS.Text variant="Body Small/Regular">Open the iPhone’s Settings app</DS.Text>
        </DS.Frame>
        <DS.Frame style={styles.stepContainer}>
          <DS.Icon name="Arrow---right" size={15} color="Global/Black" />
          <DS.Text variant="Body Small/Regular">Navigate to Apple Account</DS.Text>
        </DS.Frame>
        <DS.Frame style={styles.stepContainer}>
          <DS.Icon name="Arrow---right" size={15} color="Global/Black" />
          <DS.Text variant="Body Small/Regular">Select Subscriptions</DS.Text>
        </DS.Frame>
      </DS.Frame>

      <DS.Frame style={styles.buttonContainer}>
        <DS.Button
          variant="Large/Primary"
          type="On Light"
          onPress={() => Linking.openURL('https://apps.apple.com/account/subscriptions')}
        >
          Open Settings
        </DS.Button>
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  headerNumber: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginVertical: 8,
    gap: 8
  },
  surveyContainer: {
    flexGrow: 1,
    backgroundColor: `${DS.palette['Global/White']}80`,
    padding: 24,
    marginHorizontal: 24,
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    paddingBottom: 12
  },
  checkButton: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: DS.palette['Global/White'],
    gap: 12
  },
  checkContainer: {
    gap: 4
  },

  checkButtonContainer: {
    backgroundColor: DS.palette['Global/White'],
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    gap: 12
  },
  stepContainer: {
    flexDirection: 'row',
    gap: 4
  },
  buttonContainer: {
    position: 'relative',
    width: '100%',
    marginTop: 12
  }
})

export default CancellationSurveyStep2
